import { CanDeactivateFn } from '@angular/router';
import { HasChanges } from './models';
import { inject } from '@angular/core';
import { Observable, from, map, mergeMap, of, take } from 'rxjs';
import { DialogService } from '@core/services/dialog/dialog-service';
import { isInnerTabAllowedWithChangesNavigation } from './inner-tab-allowed-with-changes-navigation';

export const unsavedChangesGuard: CanDeactivateFn<HasChanges> = (component, _route, currentState, nextState): Observable<boolean> => {
    const dialogService = inject(DialogService);

    if (nextState && isInnerTabAllowedWithChangesNavigation(currentState, nextState)) {
        return of(true);
    }

    const continueAfterAutosave$ = component.autosaveInProgress
        ? from(dialogService.openAutosaveInProgressDialog())
        : of(true);

    return continueAfterAutosave$.pipe(
        mergeMap(allowLeaveAfterAutosavePrompt => {
            if (!allowLeaveAfterAutosavePrompt) {
                return of(false);
            }
            if (component.hasChanges) {
                return from(dialogService.openUnsavedChangesDialog()).pipe(
                    map(isDiscarded => isDiscarded)
                );
            }
            return of(true);
        }),
        take(1)
    );
};
